module.exports = __webpack_public_path__ + "img/file_jpg.414a3a5c.png";